export default function(state = {}, action){
    switch(action.type){
        case "SET_AGENT_INFO":
            return action.payload;
        case "MODIFY_AGENT_INFO":
            //return Object.assign( {}, ...state, { data: Object.assign( {}, ...state, action.payload ) } );
            return {...state, ...action.payload};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/agentInfo.js